import { z } from 'zod';
import { FORM_ANSWER_TYPES } from '../../constants';

export const questionDataSchema = z.object({
  question_id: z.number().int().positive(),
  question: z.string(),
  instructions: z.string().nullable().optional(),
  type: z.enum(FORM_ANSWER_TYPES),
  options: z
    .array(
      z.object({
        id: z.union([z.string(), z.number()]),
        option: z.string(),
        score: z.number().optional(),
      })
    )
    .optional(),
  i18n: z.record(z.string(), z.record(z.string(), z.string())).optional(),
});
export type QuestionDataInput = z.infer<typeof questionDataSchema>;

/**
 * A question block stores only this reference. The full question (text, type, options,
 * i18n) lives in the questions table and is injected at render time via
 * `config.availableQuestions`, so it is never denormalized into the step content.
 */
export const questionRefSchema = z.object({
  question_id: z.number().int().positive(),
});
export type QuestionRefInput = z.infer<typeof questionRefSchema>;
